module.exports = __webpack_public_path__ + "img/news-featured.ee9666e7.jpg";